import { render, staticRenderFns } from "./Tabela.vue?vue&type=template&id=d9d64186&scoped=true"
import script from "./Tabela.vue?vue&type=script&setup=true&lang=js"
export * from "./Tabela.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9d64186",
  null
  
)

export default component.exports